/**
 * JS based off IS+ support team's code snippet
 */

var __isp_options = __isp_options || {};

var isp_related_options = isp_related_options || {};

isp_related_options.with_product_attributes = true;

var runOnlyOnInit = false

/* =========================
    Loading Spinner Functions
   ========================= */

// Create and append the loading spinner element to the body
function createLoadingSpinner() {
  const spinner = document.createElement('div');
  spinner.className = 'isp-loading-spinner';
  document.body.appendChild(spinner);
}

// Show the loading spinner
function showLoadingSpinner() {
  const spinner = document.querySelector('.isp-loading-spinner');
  if (spinner) {
    spinner.style.display = 'block';
  }
}

// Hide the loading spinner
function hideLoadingSpinner() {
  const spinner = document.querySelector('.isp-loading-spinner');
  if (spinner) {
    spinner.style.display = 'none';
  }
}

// Initialize the spinner when the page loads
createLoadingSpinner();
hideLoadingSpinner();

// Attach global AJAX event handlers using jQuery
$(document).ajaxStart(function() {
  showLoadingSpinner();
});

$(document).ajaxStop(function() {
  hideLoadingSpinner();
  ensureFloatingButtons();
});

/* ============================
    Floating Buttons Management
   ============================ */

// Function to ensure floating buttons are visible or hidden based on filter panel state
function ensureFloatingButtons() {
 // Toggle buttons when mobile filter button is clicked
const filterButton = document.querySelector('.smart-collection__mobile-filter-button');
filterButton.addEventListener("click", function() {
  const isFilterButtonOpen = filterButton.classList.contains('opened');

  // Check if the filter panel is opened
  if (isFilterButtonOpen) {
    // Panel is opened, create the buttons if they don't exist already
    let floatingButton = document.querySelector('.floating-button-wrapper');

    if (!floatingButton) {
      // Create buttons if not already created
      createClearApplyButtons('isp_search_result_page');
    } else {
      // If the buttons already exist, just make them visible
      floatingButton.style.display = 'flex';
    }
  } else {
    // Panel is closed, hide the buttons
    const floatingButton = document.querySelector('.floating-button-wrapper');
    if (floatingButton) {
      // Hide the buttons when the panel is closed
      floatingButton.style.display = 'none';
    }
  }
});

//  Add a resize event listener to ensure buttons are hidden if screen size changes dynamically
window.addEventListener('resize', function() {
  const floatingButton = document.querySelector('.floating-button-wrapper');

  if (window.innerWidth > 1024 && floatingButton) {
    // Hide buttons if the screen size is greater than 1024px
    floatingButton.style.display = 'none';
  }
});

};

// Function to create "Clear" and "Apply" buttons for the mobile filter panel
function createClearApplyButtons(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  // Create the floating wrapper and container for the buttons
  const floatingWrapper = document.createElement('div');
  floatingWrapper.className = 'floating-button-wrapper';

  const floatingDiv = document.createElement('div');
  floatingDiv.className = 'floating-button-container';

  // Create the "Clear" button
  const clearButton = document.createElement('button');
  clearButton.className = 'isp-floating-btn isp-floating-btn-clear';
  clearButton.textContent = 'Clear';

  // Create the "Apply" button
  const applyButton = document.createElement('button');
  applyButton.className = 'isp-floating-btn isp-floating-btn-apply';
  applyButton.textContent = 'Apply';

  // Append buttons to the container
  floatingDiv.appendChild(clearButton);
  floatingDiv.appendChild(applyButton);
  floatingWrapper.appendChild(floatingDiv);
  container.appendChild(floatingWrapper);


  // Event listener for the "Apply" button
  applyButton.addEventListener('click', () => {
    const mobileFilterButton = document.querySelector('.smart-collection__mobile-filter-button');
    if (mobileFilterButton) {
      // Toggle classes to close the filter panel
      mobileFilterButton.classList.toggle('opened');
      document.querySelector('.isp_left_container').classList.toggle('opened');
      document.querySelector('.isp_center_container').classList.toggle('closed');
      floatingWrapper.remove();
    }
  });

  // Event listener for the "Clear" button
  clearButton.addEventListener('click', () => {
    // Reset filters by reloading the page without query parameters
    setTimeout(() => {
      const url = window.location.origin + window.location.pathname;
      window.location.href = url;
    }, 50);
    floatingWrapper.remove();
  });
}

const renderPageNumber = function (num, currentPage) {
    // Extract the current query parameters without page numbers
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('page', num);
    // Rebuild the pagination link with existing filters
    const pageLink = window.location.origin + window.location.pathname + `?${urlParams.toString()}`;

  if (num !== currentPage) {
    return`<a class='smart-collection__pagination__page' href='${pageLink}'>${num}</a>`
  }

  return `<span class='smart-collection__pagination__current'>${num}</span>`
}

const renderRange = function (firstNum, lastNum, currentPage) {
  var pages = []

  for (var i = firstNum; i <= lastNum; i++) {
    pages.push(renderPageNumber(i, currentPage))
  }
  return pages
}

const renderDots = function (className) {
  let text = window.innerWidth >= 768 ? '. . .' : '...'
  return `<span class='${className}'>${text}</span>`
}

// renders the start of the pagination
// i.e 1 2 ... current range
const renderStart = function () {
  // only get the first 3 or 2 pages
  let pagesBeforeDots = window.innerWidth >= 768 ? 2 : 1
  let pages = renderRange(1, pagesBeforeDots)
  pages.push(renderDots('dots-start'))

  return pages
}

// render end of pagination
// i.e current range ... 9 10
const renderFinish = function (lastPage) {
  // get the last 1 or 2 pages
  let pagesAfterDots = lastPage - (window.innerWidth >= 768 ? 1 : 0)
  let pages = renderRange(pagesAfterDots, lastPage)
  pages.unshift(renderDots('dots-finish'))

  return pages
}

__isp_options.isp_serp_callback = function (data, facetsOnly) {
  if (window.quickViewCB) window.quickViewCB(data, facetsOnly)

  if (!runOnlyOnInit) {
    $('#search_res_sorting_title').text('Sort by')

    if (window.innerWidth >= 1024) {
      $('#isp_search_result_page_container').prepend($('.isp_center_container_header'))
    } else {
      $('#isp_left_container').prepend($('.isp_center_container_header') )
    }

    window.addEventListener('resize', (evt) => {
      if (window.innerWidth >= 1024) {
        $('#isp_search_result_page_container').prepend($('.isp_center_container_header'))
      } else {
        $('#isp_left_container').prepend($('.isp_center_container_header') )
      }
    })

    $('.smart-collection__mobile-filter-button').click((evt) => {
      $('.smart-collection__mobile-filter-button').toggleClass('opened')
      $('.isp_left_container').toggleClass('opened')
      $('.isp_center_container').toggleClass('closed')
    })

    $('.smart-collection__pagination__button__prev').click((evt) => {
      evt.preventDefault()
      $('.isp_pagination .prev').click()
    })

    $('.smart-collection__pagination__button__next').click((evt) => {
      evt.preventDefault()
      $('.isp_pagination .next').click()
    })

    runOnlyOnInit = true
  }

  if (!facetsOnly) {
    // --- Update current page + total pages in UI ---
    const currentPage = data.p
    const totalPages = data.total_p
    const paginationTextWrapper = $('.smart-collection__pagination__text')
    const pageLimit = window.innerWidth >= 768 ? 6 : 3 // show more pages on desktop

    $('.smart-collection__pagination__current').text(currentPage)
    $('.smart-collection__pagination__max').text(totalPages)

    // Clear any old page numbers before rendering
    paginationTextWrapper.empty()

    // --- Render pagination numbers ---
    if (totalPages <= pageLimit + 2) {
      // Case 1: Small number of pages → just show all
      paginationTextWrapper.append(renderRange(1, totalPages, currentPage))
    } else if (currentPage <= pageLimit) {
      // Case 2: User is near the beginning
      paginationTextWrapper.append(renderRange(1, pageLimit + 2, currentPage))
      paginationTextWrapper.append(renderFinish(totalPages))
    } else if (currentPage > totalPages - pageLimit) {
      // Case 3: User is near the end
      paginationTextWrapper.append(renderStart())
      const startPage = Math.max(totalPages - pageLimit, 1)
      paginationTextWrapper.append(renderRange(startPage, totalPages, currentPage))
    } else {
      // Case 4: User is in the middle
      const neighbors = window.innerWidth >= 768 ? 2 : 1
      paginationTextWrapper.append(renderStart())
      paginationTextWrapper.append(renderRange(
        currentPage - neighbors,
        currentPage + neighbors,
        currentPage
      ))
      paginationTextWrapper.append(renderFinish(totalPages))
    }

    // --- Show/hide prev/next buttons ---
    const $prevBtn = $('.smart-collection__pagination__button__prev')
    const $nextBtn = $('.smart-collection__pagination__button__next')

    if (totalPages === 0) {
      $prevBtn.hide()
      $nextBtn.hide()
    } else if (currentPage === 1) {
      $prevBtn.hide()
      $nextBtn.show()
    } else if (currentPage === totalPages) {
      $prevBtn.show()
      $nextBtn.hide()
    } else {
      $prevBtn.show()
      $nextBtn.show()
    }
  }

  // add total results to window
  window.TOTAL_RESULTS_COUNT = data.total_results;
  // dispatch custom event with total results
  window.dispatchEvent(new CustomEvent('totaResults:totalResultsCount', { detail: { total: data.total_results } }));

  const imageTitleEls = [...document.querySelectorAll('.isp_product_info .isp_product_image_href')]
  imageTitleEls.forEach((imageTitleEl, i) => {
    imageTitleEl.insertAdjacentHTML('afterend', `
      <a class="isp_product_reviews" href="${data.items[i].u}#reviews">
        <div class="yotpo-widget-instance"
          data-yotpo-instance-id="${ window.akc.yotpo.starsWidgetInstanceID }"
          data-yotpo-product-id="${data.items[i].id}"
          data-yotpo-cart-product-id="${data.items[i].id}"
          data-yotpo-section-id="template-collection">
        </div>
      </a>
    `)
  })

  try {
    if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
      yotpoWidgetsContainer.initWidgets();
    }
  } catch (error) {
    console.error('Yotpo widgets initialization failed:', error);
  }

  // Adding title attribute to all Product titles
  $('.isp_product_title').each(function() {
    $(this).attr('title', $(this).text());
  });

  // Making sure that floating button runs
  ensureFloatingButtons();
}
/**
  if ($('.filter-input').length < 1) {
    $jquery_isp('.isp_facet_title').each(function () {
      let checkParent = $(this).parent().attr('class').match(/[\d\w-_]+/g)[1];
      let parentData = document.querySelector('.' + checkParent);

      if ($(parentData).children('.isp_facet_value').length > 2)
        $(this).after('<input type="text" isp_ignore class="filter-input" placeholder="Refine Search">')
    });
  }

  $(document).on('click', '.filter-input', function () {
    // locate parent div of clicked
    let clickedInput = $(this).parent().attr('class').match(/[\d\w-_]+/g)[1]
    let searchInput = document.querySelector(`.${clickedInput} .filter-input`);

    // get all title
    let titles = document.querySelectorAll(`.isp_single_facet_wrapper.${clickedInput} .isp_facet_value`);
    let searchTerm = '';
    let tit = '';

    // get input field and add 'keyup' event listener
    searchInput.addEventListener('keyup', (e) => {
      e.stopImmediatePropagation(); //run function once
      let showHide = $(`.${clickedInput} .isp_facet_show_hide_values`)

      if ($(`.isp_single_facet_wrapper .${clickedInput} .isp_facet_unvisible_values`).css('display') === 'none') {
        showHide.trigger('click');
      }

      // get input fieled value and change it to lower case
      searchTerm = e.target.value.toLowerCase();

      titles.forEach((title) => {
        // navigate to p in the title, get its value and change it to lower case
        tit = title.textContent.toLowerCase();

        // it search term not in the title's title hide the title. otherwise, show it.
        tit.includes(searchTerm) ? title.style.display = 'block' : title.style.display = 'none';
      });

      // if we have 3 or less remaining items from the filter, hide the show more button
      $(`.${clickedInput} .isp_facet_value[style="display: block;"]`).length <= 3 ? showHide.hide() : showHide.show()
    });
  });
 *
 */
